import { Stack, Tabs, Title } from '@mantine/core'
import { createFileRoute, Outlet, redirect, useLocation } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_admin/admin')({
  component: RouteComponent,
  beforeLoad: ({ location }) => {
    const { pathname } = location
    if (pathname === '/admin' || pathname === '/admin/') {
      throw redirect({ to: 'users' })
    }
  },
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { pathname } = useLocation()
  const section = pathname.split('/').pop()

  return (
    <Stack gap="xl">
      <Title order={1}>Panel administracyjny</Title>
      <Tabs value={section} onChange={(value) => navigate({ to: `${value}` })}>
        <Tabs.List>
          <Tabs.Tab value="users">Użytkownicy</Tabs.Tab>
          <Tabs.Tab value="manufacturers">Producenci</Tabs.Tab>
          <Tabs.Tab value="history">Historia</Tabs.Tab>
          <Tabs.Tab value="places">Regały</Tabs.Tab>
          <Tabs.Tab value="delivery-companies">Kurierzy</Tabs.Tab>
        </Tabs.List>

        <Outlet />
      </Tabs>
    </Stack>
  )
}
